import Loadable from '../../components/loadable';

const GrandfatheredPricingPlanModal = Loadable({
  loader: () => import('../../pages/subscription/grandfathered_pricing_plan_modal'),
});

angular.module('gym').value('GrandfatheredPricingPlanModal', GrandfatheredPricingPlanModal);
